import { render, staticRenderFns } from "./AnnualCatalogProject.vue?vue&type=template&id=2c90a029"
import script from "./AnnualCatalogProject.vue?vue&type=script&lang=js"
export * from "./AnnualCatalogProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports